import { type Metric } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: (metric: Metric) => void): void => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onINP, onTTFB }) => {
      // onINP is now recommended instead of onFID
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onINP(onPerfEntry); // Using onINP instead of onFID
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
